module.exports = __webpack_public_path__ + "img/Pacing_64x64.fee6cf27.png";